import { AnnotationsChartConfigRequiredProps } from './types/annotations-chart-config-props.js';
import {
  DEFAULT_SHOW_LABELS,
  DEFAULT_LABELS_WIDTH,
  DEFAULT_TEXT_OVERFLOW,
  DEFAULT_TRUNCATION_MODE,
} from '../core/components/annotations/constants.js';
import { TextOverflowTruncateOptions } from '../core/components/annotations/types/marker.js';

export const DEFAULT_AXIS_HIDDEN = false;

export const DEFAULT_NUMERICAL_AXIS_TYPE = 'linear';

export const DEFAULT_TOOLTIP_HIDDEN = false;

export const DEFAULT_TEXT_OVERFLOW_CONFIG: TextOverflowTruncateOptions = {
  textOverflow: DEFAULT_TEXT_OVERFLOW,
  truncateMode: DEFAULT_TRUNCATION_MODE,
};

export const DEFAULT_ANNOTATIONS_CHART_CONFIG: AnnotationsChartConfigRequiredProps =
  {
    showLabels: DEFAULT_SHOW_LABELS,
    height: undefined,
    labelWidth: DEFAULT_LABELS_WIDTH,
    xAxisConfig: {
      hidden: DEFAULT_AXIS_HIDDEN,
    },
    tooltipConfig: {
      hidden: DEFAULT_TOOLTIP_HIDDEN,
      template: undefined,
    },
    textOverflowConfig: DEFAULT_TEXT_OVERFLOW_CONFIG,
  };

export const ANNOTATIONS_CHART_ARIA_LABEL = 'Annotations Chart';
